<template>
    <div>
        <simulationAutoDesktop v-if="isDesktop()"></simulationAutoDesktop>
        <simulationAutoMobile  v-if="isMobile()"></simulationAutoMobile>
    </div>
</template>

<script>
    import simulationAutoDesktop from "./simulate.auto.desktop.vue"
    import simulationAutoMobile from "./simulate.auto.mobile.vue"

    export default {
        name: 'AutoIndex',
        components: {
            simulationAutoDesktop,
            simulationAutoMobile
        },
        data() {
            return {
                
            }
        },

        methods: {
            isMobile: function () {
                if (screen.width <= 760) {
                    return true
                } else {
                    return false
                }
            },
  
            isDesktop: function () {
                if (screen.width > 760) {
                    return true
                } else {
                    return false
                }
            },
        },
    }
</script>